import React from "react";
import classNames from "classnames";
import { Segment } from "semantic-ui-react";

const TablePanel = ({ className, children }) => (
  <Segment className={classNames("table-panel", className)}>{children}</Segment>
);

export default TablePanel;
